import { AUTH_USER_KEY } from '@/constants/constants'
import { paths } from '@/router/paths'
import type { LoginResponse } from '@/services/auth'

export const setLoggedInUser = (payload: LoginResponse) =>
  localStorage.setItem(AUTH_USER_KEY, JSON.stringify(payload))

export const getLoggedInUser = (): LoginResponse | null => {
  const data = localStorage.getItem(AUTH_USER_KEY)
  if (!data) return null

  try {
    return JSON.parse(data) as LoginResponse
  } catch {
    cleanLoggedInUser()
    return null
  }
}

export const cleanLoggedInUser = () => localStorage.removeItem(AUTH_USER_KEY)

export const redirectToLogin = () => {
  window.location.href = paths.login
}
